import React from 'react';
import {
  Card,
  SkeletonThumbnail,
  SkeletonDisplayText,
  SkeletonBodyText,
  TextContainer,
} from '@shopify/polaris';

import * as styles from './SkeletonExpertCard.scss';

export default function SkeletonExpertCard() {
  return (
    <div
      className={styles.SkeletonExpertCard}
      aria-disabled
      aria-label="loading"
    >
      <Card>
        <div className={styles.CardContent}>
          <div className={styles.HeaderContainer}>
            <div className={styles.ThumbnailContainer}>
              <SkeletonThumbnail size="medium" />
            </div>
            <div className={styles.Heading}>
              <TextContainer spacing="tight">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={1} />
              </TextContainer>
            </div>
          </div>
          <div className={styles.ServiceMetrics}>
            {[...Array(3).keys()].map(key => (
              <div className={styles.ServiceMetric} key={key}>
                <TextContainer spacing="tight">
                  <div className={styles.MetricLabel}>
                    <SkeletonDisplayText size="small" />
                  </div>
                  <SkeletonBodyText lines={1} />
                </TextContainer>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}
